export default "__VITE_ASSET__2BazzxdF__"